import { render, staticRenderFns } from "./RemarkInfoWrongDetail.vue?vue&type=template&id=3194c2c9&scoped=true&"
import script from "./RemarkInfoWrongDetail.vue?vue&type=script&lang=js&"
export * from "./RemarkInfoWrongDetail.vue?vue&type=script&lang=js&"
import style0 from "./RemarkInfoWrongDetail.vue?vue&type=style&index=0&id=3194c2c9&scoped=true&lang=scss&"
import style1 from "./RemarkInfoWrongDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3194c2c9",
  null
  
)

export default component.exports